module.exports = __webpack_public_path__ + "img/icon-3vdots.08da1f70.svg";